import { useEffect } from 'react';
import { Breadcrumb, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigationType, useParams } from 'react-router-dom';

import { MessageType } from 'models/MessageType';
import { FullWidthSpace } from 'components/styledComponents';

import { ClaimDetails } from './components/ClaimDetails';
import { useClaimPageQuery } from '../../hooks';
import { CLAIM_STATUSES } from 'all-in-one-shared-api';

export interface LocationState {
  messageType?: MessageType;
  messageContent?: string;
  sequenceNo?: string;
  claimId: string;
}

const ClaimDetailsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { claimId } = useParams();
  const { sequenceNo, claimStatus } = useClaimPageQuery();

  const { state } = useLocation();
  const { messageContent, messageType } = (state || {}) as LocationState;

  const navigationType = useNavigationType();

  useEffect(() => {
    if (messageType && messageContent && navigationType === 'REPLACE') {
      message[messageType]({
        content: messageContent,
      });
    }
  }, [messageContent, messageType, navigationType, state]);

  return (
    <FullWidthSpace size="large" direction="vertical">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/claims">{t('claimDetails.myClaims')}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{t('claimDetails.claimDetails')}</Breadcrumb.Item>
      </Breadcrumb>

      <ClaimDetails
        claimId={claimId || ''}
        sequenceNo={sequenceNo}
        isShortfall={claimStatus === CLAIM_STATUSES.SHORTFALL}
      />
    </FullWidthSpace>
  );
};
export default ClaimDetailsPage;
